import { render, staticRenderFns } from "./RRRTransactionHistory.vue?vue&type=template&id=58dda99c&"
import script from "./RRRTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./RRRTransactionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports